export default "__VITE_ASSET__DLRF_xQz__"